import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface GasLinesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GasLines: React.FC<GasLinesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [gasLines, set_gasLines] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Utilities']?.['Gas Lines'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Utilities': { ...b.values?.['Utilities'], 'Gas Lines': v } } })
    );
    const label = 'Gas Lines';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(gasLines)}
                />
            ) : (
                <MoneyBox
                    id={'gasLines'}
                    allowNegative={false}
                    value={gasLines}
                    onChange={(value) => set_gasLines(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
